<template>
  <div class="home wrapper">
    <div class="content">
      <Header></Header>
      <Loading :loading="loading"></Loading>

      <div :class="{ 'hidden': loading }">
        <Breadcrumb :breadcrumbs="breadcrumbs"></Breadcrumb>
        <Title :title="content.category"></Title>

        <div class="container items-container">
          <div class="row">
            <div class="col-12 col-md-2">
              <YearsFilter></YearsFilter>
            </div>
            <!-- /.col-12 col-md-2 -->
          </div>
          <!-- /.row -->

          <div class="row">
            <div class="col-12">

              <div class="atos-oficiais">
                <h2 class="atos-oficiais-ano">
                  {{ content.year }}
                </h2>
                <!-- /.atos-oficiais-ano -->
                <Arquivo v-for="item in content.items" :title="item.title" :file="item.url"></Arquivo>
              </div>
              <!-- /.atos-oficiais -->

              <NotFoundItems :content="content.items"/>

            </div>
          </div>
          <!-- /.row -->
        </div>
        <!-- /.container -->

      </div>
      <!--== /.hidden ==-->

    </div>
    <!-- /.content -->

    <Footer></Footer>
  </div>
  <!-- /.home wrapper -->
</template>

<script>
  import Header from '../../components/Header.vue';
  import Footer from '../../components/Footer.vue';
  import Breadcrumb from '../../components/Breadcrumb.vue';
  import Arquivo from '../../components/generic/Arquivo.vue';
  import Title from '../../components/generic/Title.vue';
  import Loading from '../../components/generic/Loading.vue';
  import axios from 'axios';
  import env from '../../config/env';
  import YearsFilter from '../../components/generic/Filters/Years.vue';
  import hasItemInObject from '../../utils/hasItemInObject';
  import NotFoundItems from '../../components/generic/NotFoundItems';

  export default {
    name: 'arquivos',
    components: {
      Header,
      Footer,
      Breadcrumb,
      Arquivo,
      Title,
      Loading,
      YearsFilter,
      NotFoundItems
    },
    data () {
      return {
        content: [],
        loading: true,
        breadcrumbs: [
          {
            name: 'Início',
            link: '/'
          },
          {
            name: 'Gestão e Governança',
            link: '/gestaoegovernanca'
          },
          {
            name: 'Atos Oficiais',
            link: '/gestaoegovernanca/atosoficiais'
          }
        ]
      }
    },
    methods: {
      requestData() {
        axios
          .get(`${env.api.ARQUIVOS_ATOS_OFICIAIS}/${this.$route.params.subcategory}/${this.$route.params.year ? this.$route.params.year : new Date().getFullYear()}`)
          .then(response => {
            this.content = response.data;
            this.loading = false;

            if (!hasItemInObject.hasItem(this.breadcrumbs, this.content.category)) {
              this.breadcrumbs.push(
                {
                  name: response.data.parentCategory,
                  link: `/gestaoegovernanca/atosoficiais/${response.data.parentSlug}`
                },
                {
                  name: response.data.category,
                }
              );
            }

          });
      }
    },
    mounted () {
      this.requestData();
    },
    watch: {
      '$route' () {
        this.loading = true;

        this.requestData();
      }
    }
  };
</script>

<style scoped lang="scss">
  .atos-oficiais {
    margin-bottom: 20px;
  }

  .atos-oficiais-ano {
    margin-bottom: 20px;

    font-family: 'Lato', sans-serif;
    font-weight: 700;
    text-align: center;
    color: #396b84;
  }
</style>
